import { Component, OnInit, AfterContentChecked, ViewChild } from '@angular/core';
import { Noticia } from '../../../../../interfaces/noticia';
import { VerArchivosNoticiaComponent } from '../../../../../forms/noticias/archivos-noticia/ver-archivos-noticia/ver-archivos-noticia.component';
import { MatTabGroup, MatSnackBar, MatTabChangeEvent } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { DetalleService, DetalleNombre } from '../../../../../providers/detalle.service';
import { NoticiaService } from '../../../../../providers/noticia.service';

@Component({
  selector: 'app-detalle-noticia-pagina',
  templateUrl: './detalle-noticia-pagina.component.html',
  styleUrls: ['./detalle-noticia-pagina.component.scss']
})
export class DetalleNoticiaPaginaComponent implements OnInit, AfterContentChecked {
  cargando: boolean = true;
  IdNoticia?: number | string;
  noticia: Noticia;
  tabSelectedIndex: number = 0;

  @ViewChild('archivosNoticia') archivosNoticia: VerArchivosNoticiaComponent;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;

  constructor(
    private route: ActivatedRoute,
    private noticiaService: NoticiaService,
    private snackBar: MatSnackBar,
    private detalleService: DetalleService
  ) { }

  ngOnInit() {
    this.noticia = new Noticia();

    this.route.params.subscribe(params => {
      this.IdNoticia = params['id'];
      this.actualizarDetalle();
    });
  }

  ngAfterContentChecked() {
    if (this.tabGroup && this.tabGroup._tabs && this.tabGroup._tabs.length > 1) {
      this.tabSelectedIndex = this.detalleService.getDetalleTabActivo(DetalleNombre.DETALLE_NOTICIA);
    }
  }

  // get active tab on change
  selectedTabChange(event: MatTabChangeEvent): void {
    var tabActivo = +event.index;
    this.detalleService.setDetalleTabActivo(DetalleNombre.DETALLE_NOTICIA, tabActivo);
  }

  actualizarArchivos(): void { // actualizar 
    this.archivosNoticia.IdNoticia = this.IdNoticia;
    this.archivosNoticia.actualizarTabla();
  }

  actualizarDetalle(): void { // traer datos
    this.cargando = true;
    this.noticiaService.getNoticias(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        IdNoticia: this.IdNoticia
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          var noticia = respuesta.data.noticias[0];
          if (noticia) {
            respuesta.data.noticias.forEach(noticia => {
              this.noticia = new Noticia(
                noticia.id,
                noticia.titulo,
                noticia.cuerpo,
                !!+noticia.mostrarWeb,
                noticia.fecha,
                noticia.fechaNoticia
              );
            });

            setTimeout(() => {
              this.actualizarArchivos();
            }, 10);
          } else {
            this.snackBar.open('No se encontraron los datos buscados', 'OK', { duration: 2750 });
          }
        }
      },
      () => {
        this.cargando = false;
      },
      () => {
        this.cargando = false;
      }
    );
  }
}
